import { type Appearance, AppearanceSchema, DEFAULT_APPEARANCE } from '@pm/schemas';

export const APPEARANCE_STORAGE_KEY = 'pm.appearance';

/** Resolve 'system' para dark/light conforme o SO. */
export function resolveTheme(theme: Appearance['theme']): 'dark' | 'light' {
  if (theme !== 'system') return theme;
  if (typeof window === 'undefined' || !window.matchMedia) return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

/** Aplica os atributos data-* em <html>. Tudo no CSS reage a eles (tokens.css). */
export function applyAppearance(a: Appearance, root: HTMLElement = document.documentElement): void {
  root.setAttribute('data-theme', resolveTheme(a.theme));
  root.setAttribute('data-accent', a.accent);
  root.setAttribute('data-density', a.density);
  root.setAttribute('data-font-sans', a.font_sans);
  root.setAttribute('data-font-mono', a.font_mono);
}

export function readStoredAppearance(): Appearance {
  try {
    const raw = localStorage.getItem(APPEARANCE_STORAGE_KEY);
    if (!raw) return DEFAULT_APPEARANCE;
    const parsed = AppearanceSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : DEFAULT_APPEARANCE;
  } catch {
    return DEFAULT_APPEARANCE;
  }
}

export function storeAppearance(a: Appearance): void {
  try {
    localStorage.setItem(APPEARANCE_STORAGE_KEY, JSON.stringify(a));
  } catch {
    /* storage indisponível: preferência só vale na sessão */
  }
}
